var map = {
	"./Icons.svg": 7255,
	"./bg-pesa.svg": 6158,
	"./currency-pesa.svg": 7662,
	"./currency-ssp.svg": 7715,
	"./currency-usd.svg": 9413,
	"./eye-logo.png": 2408,
	"./icon-acc-logout.svg": 9175,
	"./icon-account.svg": 66,
	"./icon-activity.svg": 3126,
	"./icon-added-pool.svg": 1684,
	"./icon-adding.svg": 6342,
	"./icon-agent.png": 630,
	"./icon-arrow-back.svg": 7224,
	"./icon-arrow-exchange-green.png": 2424,
	"./icon-arrow-exchange-green.svg": 1872,
	"./icon-arrow-exchange.svg": 8018,
	"./icon-arrow-in.svg": 740,
	"./icon-arrow-left.svg": 4082,
	"./icon-arrow-out.svg": 5627,
	"./icon-arrow-right.svg": 2745,
	"./icon-arrow-trans.svg": 8529,
	"./icon-buy.svg": 7099,
	"./icon-charity.svg": 1943,
	"./icon-checbox-filled.svg": 6128,
	"./icon-check.svg": 6799,
	"./icon-close-gray.svg": 2033,
	"./icon-close-modal.svg": 6823,
	"./icon-close-toast.svg": 6025,
	"./icon-code-key.png": 5460,
	"./icon-contacts.svg": 814,
	"./icon-copy.svg": 8454,
	"./icon-dashboard.svg": 5991,
	"./icon-dec-cancel.svg": 6266,
	"./icon-deposit.svg": 1317,
	"./icon-drop-down.svg": 3599,
	"./icon-edit-gray.svg": 5223,
	"./icon-edit.svg": 5837,
	"./icon-emoji.svg": 4309,
	"./icon-failed.svg": 3114,
	"./icon-id.png": 4046,
	"./icon-id.svg": 9466,
	"./icon-id@2x.png": 8630,
	"./icon-incoming.svg": 6721,
	"./icon-info.svg": 3029,
	"./icon-left-arrow.svg": 4610,
	"./icon-licence.png": 8548,
	"./icon-licence.svg": 1726,
	"./icon-licence@2x.png": 4036,
	"./icon-logout.svg": 9855,
	"./icon-n-attention.svg": 5548,
	"./icon-n-error.svg": 5080,
	"./icon-n-info.svg": 922,
	"./icon-n-success.svg": 1491,
	"./icon-notification-gray.svg": 5096,
	"./icon-notification-red.svg": 8094,
	"./icon-notification.svg": 7676,
	"./icon-notifications.svg": 1223,
	"./icon-outgoing.svg": 3047,
	"./icon-passport.png": 2799,
	"./icon-passport@2x.png": 7697,
	"./icon-phone-bg.svg": 3485,
	"./icon-phone.svg": 3083,
	"./icon-pool.png": 2667,
	"./icon-received.svg": 9500,
	"./icon-rejected.svg": 4643,
	"./icon-reward.svg": 4820,
	"./icon-search.svg": 1049,
	"./icon-select.svg": 9601,
	"./icon-send.svg": 6911,
	"./icon-sent.svg": 3343,
	"./icon-settings.svg": 8026,
	"./icon-star-default.svg": 3689,
	"./icon-star.svg": 4957,
	"./icon-step.svg": 5867,
	"./icon-success.svg": 5306,
	"./icon-textfield-eye-hidden.svg": 8277,
	"./icon-textfield-eye.svg": 2224,
	"./icon-time.svg": 5126,
	"./icon-transactions-pool.svg": 4841,
	"./icon-transactions.svg": 1278,
	"./icon-type-buy.svg": 8462,
	"./icon-type-withdrawal.svg": 2335,
	"./icon-upload.svg": 9298,
	"./icon-wallet.svg": 3778,
	"./icon-warning.png": 7569,
	"./icon-withdraw.svg": 8515,
	"./icon-you.svg": 6958,
	"./icon-zoom.svg": 5324,
	"./icon_email.svg": 4153,
	"./icon_laptop.svg": 4611,
	"./icon_or_in.svg": 3858,
	"./icon_or_out.svg": 1477,
	"./icon_pc.svg": 2296,
	"./icon_phone.svg": 3889,
	"./icon_question.svg": 2747,
	"./icon_read_check.svg": 7822,
	"./icon_rotate.svg": 58,
	"./icon_scale_max.svg": 984,
	"./icon_scale_min.svg": 382,
	"./icon_wallet.svg": 3224,
	"./rate.svg": 1953,
	"./safe.svg": 9892,
	"./swift.svg": 8212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8157;